import { render, staticRenderFns } from "./SearchProfiles.vue?vue&type=template&id=2f3e0ac6&scoped=true"
import script from "./SearchProfiles.vue?vue&type=script&lang=js"
export * from "./SearchProfiles.vue?vue&type=script&lang=js"
import style0 from "./SearchProfiles.vue?vue&type=style&index=0&id=2f3e0ac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3e0ac6",
  null
  
)

export default component.exports